import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-multilevel-menu',
  templateUrl: './multilevel-menu.component.html'
})
export class MultilevelMenuComponent implements OnInit {

  @Input() secondLevelMenu
  @Input() thirdLevelMenu
  @Input() fourthLevelMenu
  @Input() selectedContent
  @Input() safeZone
  fourthLevelMenuMode
  @Input() backgrounds
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  clickAction(data) {
    if (data[0]?.data.content_menu?.length > 0) {
      this.selectedContent = data[0].data.content_menu
    }
    switch (data[1]) {
      case 2: {
        this.changeThirdLevel(data)
        this.closeSecondLevel(data)
        this.closeThirdLevel(data)
        this.closeFourthLevel(data)
        break
      }
      case 3: {
        this.changeFourthLevel(data)
        this.closeThirdLevel(data)
        this.closeFourthLevel(data)
        break
      }
      case 4: {
        this.closeFourthLevel(data)
        break
      }
    }
  }

  changeFourthLevel(data) {
    if (data[0].data.same_column) {
      this.fourthLevelMenuMode = 'same_column'
      if (this.fourthLevelMenu !== data[0]) {
        data[0].data.isCollapse = true
        this.fourthLevelMenu = data[0]
      } else {
        this.fourthLevelMenu = null
      }
    } else {
      if (this.fourthLevelMenu !== data[0]) {
        this.fourthLevelMenu = data[0]
      } else {
        this.fourthLevelMenu = null
      }
      this.fourthLevelMenuMode = 'new_column'
    }
  }

  changeThirdLevel(data) {
    this.fourthLevelMenu = null
    this.fourthLevelMenuMode = null

    if(data?.children?.length === 0){
      this.thirdLevelMenu = null
      return
    }

    if (this.thirdLevelMenu !== data[0]) {
      this.thirdLevelMenu = data[0]
    }
  }

  closeSecondLevel(data) {
    this.secondLevelMenu?.forEach(secondLevelItem => {
      if (secondLevelItem !== data[0]) {
        secondLevelItem.data.active = false
      }
    })
  }

  closeThirdLevel(data) {
    this.thirdLevelMenu?.children?.forEach(thirdLevelItem => {
      if (thirdLevelItem !== data[0]) {
        thirdLevelItem.data.active = false
        thirdLevelItem.data.isCollapse = false
      }
    })
  }

  closeFourthLevel(data) {
    this.fourthLevelMenu?.children?.forEach(fourthLevelItem => {
      if (fourthLevelItem !== data[0]) {
        fourthLevelItem.data.active = false
      }
    })
  }





}
